export default "__VITE_ASSET__85cdd4ca__"